
    export default {
        name: 'TechnologySection',
        computed: {
            technologyItems() {
                return this.$store.state.technologyData;
            },
        },
    };
